import { Heading, Paragraph } from "../../../atoms";
import { Box, Flex } from "../../../cores";
import { useViewContext } from "../../../hooks";
import { IconAsterisk, IconColoredNumber } from "../../../icons";

interface ITextWithColoredNumberAndAsterisk {
  descriptionTitle: string;
  paragraphAsterisk: boolean;
  descriptionText: Array<string>;
}

const TextWithColoredNumberAndAsteriskDescription = ({
  descriptionTitle,
  paragraphAsterisk,
  descriptionText,
}: ITextWithColoredNumberAndAsterisk) => {
  const { isMobile } = useViewContext();
  return (
    <Box
      sx={{
        width: ["100%", null, null, "50%", "50%"],
        "> div": {
          marginY: 10,
          "> p": {
            marginLeft: "sm",
            fontSize: ["xs", null, "16px", null, null],
          },
        },
      }}
    >
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {descriptionTitle}
      </Heading>
      <Flex>
        <IconColoredNumber value={"3"} />
        <Paragraph>
          {paragraphAsterisk ? descriptionText[3] : descriptionText[2]}
        </Paragraph>
      </Flex>
      <Flex>
        <IconColoredNumber value={"2"} />
        <Paragraph>
          {paragraphAsterisk ? descriptionText[2] : descriptionText[1]}
        </Paragraph>
      </Flex>
      <Flex>
        <IconColoredNumber value={"1"} />
        <Paragraph>
          {paragraphAsterisk ? descriptionText[1] : descriptionText[0]}
        </Paragraph>
      </Flex>

      {paragraphAsterisk ? (
        <Flex>
          <IconAsterisk />
          <Paragraph>{descriptionText[0]}</Paragraph>
        </Flex>
      ) : null}
    </Box>
  );
};

export default TextWithColoredNumberAndAsteriskDescription;
